"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.drawerButton = void 0;
const drawerButton = () => {
    const draws = document.querySelectorAll('.drawer-outer');
    document.addEventListener('click', (event) => {
        const target = event.target;
        if (!target.matches('.drawer-button')) {
            draws.forEach((draw) => {
                if (draw.classList.contains('drawer-open')) {
                    draw.classList.remove('drawer-open');
                }
            });
        }
        else {
            if (target.closest('.drawer-outer').classList.contains('drawer-open')) {
                draws.forEach((draw) => {
                    if (draw.classList.contains('drawer-open')) {
                        draw.classList.remove('drawer-open');
                    }
                });
            }
            else {
                draws.forEach((draw) => {
                    if (draw.classList.contains('drawer-open')) {
                        draw.classList.remove('drawer-open');
                    }
                });
                target.closest('.drawer-outer').classList.add('drawer-open');
            }
        }
    });
};
exports.drawerButton = drawerButton;
